import { ResponseTypes } from '../../funds/funds-generated';
// replicates AutocompleteItem but with optional TextPrefix
// ReSharper disable InconsistentNaming
export type IntegrationFundDisplayItem = {
	Text: string;
	TextPrefix?: string;
	Value: string;
	AdditionalText?: string;
	ClassName?: string;
};
// ReSharper restore InconsistentNaming

export default function getIntegrationFundAutocompleteItems(funds: ResponseTypes.IntegrationFundViewModel[]):
	IntegrationFundDisplayItem[] {

	const sortableNames = funds.reduce((val, item) => {
			val[item.Key] = item.Name.toLowerCase();
			return val;
		}, {});

	return funds
		.orderBy(x => sortableNames[x.ParentFundKey || x.Key])
		.thenBy(x => !!x.ParentFundKey)
		.thenBy(x => sortableNames[x.Key])
		.toArray().map(toIntegrationFundDisplayItem);
}

function toIntegrationFundDisplayItem(fund: ResponseTypes.IntegrationFundViewModel): IntegrationFundDisplayItem {
	const text = `${fund.Name}${fund.Code !== null ? ` (${fund.Code})` : ``}`;
	const FUND_MAPPING_LABEL = 'Mapped';
	const HIGHLIGHT_CLASS = 'highlight';

	return {
		Value: fund.Key,
		Text: text,
		TextPrefix: fund.ParentFundKey ? '-' : '',
		AdditionalText: fund.IsMappedToGivingFund ? FUND_MAPPING_LABEL : '',
		ClassName: fund.IsMappedToGivingFund ? HIGHLIGHT_CLASS : ''
	};
}
